import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  root: {
    position: "sticky",
    top: 20,
    zIndex: 1300,
    // width: "100vw"
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      top: 30,
      justifyContent: "space-evenly"
    }
  },
  rootScrollList: {
    position: "sticky",
    top: 99,
    zIndex: 1300,
    // width: "100vw"
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      top: 99,

      justifyContent: "space-evenly"
    }
  },
  paper: {
    height: 140,
    width: 100
  },
  columnContainer: {
    [theme.breakpoints.down("xs")]: {
      maxWidth: "45%",
      width: "45%"
    }
  },
  mainContainer: {
    width: "20vw",
    textAlign: "center",
    margin: "20px 20px",
    [theme.breakpoints.down("xs")]: {
      width: "35vw"
    }
  },
  buttonPlan: {
    minWidth: "120px",
    textTransform: "none"
  },
  marginBottomContainer: {
    marginBottom: "50px"
  },
  rootButtons: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-evenly"
    }
  }
}));

export default styles;
